export default {
  apiHost(api_env) {
    let uri;
    switch (api_env) {
      case 'development':
        // 로컬 개발 시 localhost API 서버 사용
        uri = "https://web-server.production.fruitsfamily.com/graphql";
        break;
      case 'staging':
        uri = 'https://web-server.staging.fruitsfamily.com/graphql';
        break;
      case 'production':
        uri = 'https://web-server.production.fruitsfamily.com/graphql';
        break;
      default:
        // 기본값은 staging API
        uri = "https://web-server.production.fruitsfamily.com/graphql";
        break;
    }
    return new URL(uri);
  },
  nicepayViewURI(api_env) {
    let uri;
    switch (api_env) {
      case 'development':
      case 'staging':
        uri = 'https://web-server.staging.fruitsfamily.com/nicepay-view';
        break;
      case 'production':
        uri = 'https://web-server.production.fruitsfamily.com/nicepay-view';
        break;
      default:
        uri = 'https://web-server.staging.fruitsfamily.com/nicepay-view';
        break;
    }
    return new URL(uri);
  },
};